/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                from 'react';
import { StyledIconInline } from '../StyledIconInline';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const StyledIconMail = StyledIconInline.extend`
  height: ${props => props.height || '20px'};
  width: ${props => props.width || '26px'};
  transform: translate(1px, 1px);
`;

export const IconMail = (props) => (
    <StyledIconMail {...props}>
        <svg viewBox="0 0 26 20" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink">
            <g strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20.8911,2.8604 L12.9641,9.9884 C12.3641,10.5274 11.4141,10.5274 10.8141,9.9884 L2.8871,
                2.8604"/>
                <path d="M15.5811,10.7256 L20.8911,15.1426"/>
                <path d="M8.1978,10.7256 L2.8868,15.1426"/>
                <path d="M0.5,2.791 L0.5,15.212 C0.5,16.477 1.525,17.5 2.842,17.5 L21.15,17.5 C22.467,17.5 23.5,
                16.477 23.5,15.212 L23.5,2.791 C23.5,1.526 22.467,0.5 21.15,0.5 L2.842,0.5 C1.525,0.5 0.5,1.526 0.5,
                2.791 Z"/>
            </g>
        </svg>
    </StyledIconMail>
);



// WEBPACK FOOTER //
// ./src/components/atoms/IconMail/index.js